import { IOnboardingStepProps } from "../Onboarding";

import { View } from "./View";

export const OnboardingFive = (props: IOnboardingStepProps) => {
  return <View onSubmit={props.handleNext} {...props} />;
};
